import type { AppVersionIndicator } from '../../api/businessAppsVersions'
import './versions.css'

/**
 * Indicatorii mici din lista aplicatiilor: versiunea de pe server, cate statii
 * au alta versiune si licentele (peste / nefolosite). Fara date (aplicatie in
 * afara catalogului, sau raspunsul inca nu a venit), nu apare nimic.
 */
export function VersionBadges({ info }: { info?: AppVersionIndicator }) {
  if (!info || typeof info !== 'object' || !('licenseState' in info)) return null
  const badges: { key: string; pill: string; text: string; title: string }[] = []
  if (info.reference !== null && info.referenceFrom === 'server') {
    badges.push({ key: 'v', pill: '', text: `v${info.reference}`, title: 'Version found on the server' })
  }
  if (info.different > 0) {
    badges.push({
      key: 'd',
      pill: 'adm-pill-warn',
      text: `${info.different} ws differ`,
      title: `${info.different} workstation${info.different === 1 ? '' : 's'} run a different version than ${info.referenceFrom === 'server' ? 'the server' : 'the recorded version'}${info.older > 0 ? ` (${info.older} older)` : ''}`,
    })
  }
  if (info.licenseState === 'over') {
    badges.push({
      key: 'l',
      pill: 'adm-pill-bad',
      text: `${info.installed}/${info.seats} licenses`,
      title: `Installed on ${info.installed} workstations, ${info.seats} licenses`,
    })
  } else if (info.licenseState === 'unused') {
    badges.push({
      key: 'l',
      pill: 'adm-pill-warn',
      text: `${info.unused} licenses unused`,
      title: `${info.seats} licenses, installed on ${info.installed} workstations`,
    })
  }
  if (badges.length === 0) return null

  return (
    <span className="av-badges">
      {badges.map((b) => (
        <span key={b.key} className={`adm-pill ${b.pill}`.trim()} title={b.title}>
          {b.text}
        </span>
      ))}
    </span>
  )
}
